import { Type } from "class-transformer";
import { CalendarEvent } from "./CalendarEvent";
import { Resource } from "./Resource";

export class CalendarEventResource {
    //netgen start
    calendarEventId = 0;
    resourceId = 0;
    id = 0;
    //netgen end
}
